import _ from 'lodash';
import { Member } from 'modules/overlay-v2/domain/interfaces/game-info/gameInfoMapped';

interface IProps {
  teamMembers: Member[];
}

function getTeamPositions(props: IProps) {
  return _(props.teamMembers).filter({ isInvolved: true }).groupBy('position').value();
}

export default getTeamPositions;
